import { tabbable } from 'tabbable';
export function getElementInstance() {
  return typeof Element === 'undefined' ? function E() {} : Element;
}
export function isElement(el) {
  const E = getElementInstance();
  return el instanceof E;
}
export function contains(el, queryEl) {
  if (!isElement(el) || !isElement(queryEl)) {
    return false;
  }

  return el.contains(queryEl);
}
export function isFocused(el) {
  return contains(el, document.activeElement);
}
export const focusEndOfInput = inputElement => {
  const caretPos = inputElement.value.length;
  /* eslint-disable no-param-reassign */

  inputElement.focus();
  inputElement.selectionStart = caretPos;
  inputElement.selectionEnd = caretPos;
  /* eslint-enable no-param-reassign */
};
export function blurToEndOf(element) {
  // Hack for blurring an element but move to a specific position in the tab order
  const focusThief = document.createElement('div');
  focusThief.setAttribute('tabindex', 0);
  element.append(focusThief);
  focusThief.focus();
  focusThief.parentNode.removeChild(focusThief);
}
export const preventTabOutside = (containerElement, event) => {
  if (containerElement && event.key === 'Tab') {
    const focusableEls = tabbable(containerElement);
    const firstFocusable = focusableEls[0];
    const lastFocusable = focusableEls[focusableEls.length - 1];

    if (event.shiftKey && document.activeElement === firstFocusable) {
      event.preventDefault();
      lastFocusable.focus();
    } else if (!event.shiftKey && document.activeElement === lastFocusable) {
      event.preventDefault();
      firstFocusable.focus();
    }
  }
};
export function getFirstFocusableElement(containerElement) {
  return tabbable(containerElement)[0];
}